module.exports = __webpack_public_path__ + "img/elumiti_premia.0d1abf6f.png";